<form [formGroup]="form" (ngSubmit)="onSubmit(form)" class="container">
  <div formGroupName="single">
    <div class="form">
      <div class="info">
        <div class="form1">
          <span class="input">
            <mat-form-field style="width: 150px">
              <mat-label>LMP</mat-label>
              <input formControlName="lmp" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field style="width: 150px">
              <mat-label>G.A (LMP)</mat-label>
              <input formControlName="ga" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field style="width: 150px">
              <mat-label>EDD (LMP)</mat-label>
              <input formControlName="edd" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field style="width: 150px">
              <mat-label>Date</mat-label>
              <input
                matInput
                [matDatepicker]="dob"
                (dateChange)="DateChange($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="dob"
              ></mat-datepicker-toggle>
              <mat-datepicker #dob></mat-datepicker>
            </mat-form-field>
          </span>
        </div>

        <div class="img">
          <div class="imgBox">
            <img
              *ngIf="fullImage"
              [src]="fullImage"
              style="width: 100%; height: 100%"
              alt=""
            />
          </div>
          <div class="sel">
            <span class="input">
              <mat-form-field style="width: 150px">
                <mat-label>Images</mat-label>
                <mat-select
                  matNativeControl
                  (selectionChange)="slectOnChange1($event)"
                >
                  <mat-option
                    *ngFor="let data of image1"
                    [value]="data.OptionValue"
                    >{{ data.OptionName }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field style="width: 150px">
                <mat-label>Images</mat-label>
                <mat-select
                  matNativeControl
                  (selectionChange)="slectOnChange($event)"
                  [disabled]="disabled"
                >
                  <mat-option
                    *ngFor="let data of image2"
                    [value]="data.OptionValue"
                    >{{ data.OptionName }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </span>
          </div>
        </div>
      </div>
      <br />
      <mat-divider style="margin-bottom: 30px"></mat-divider>
      <div class="others">
        <div class="left">
          <span class="input">
            <mat-form-field>
              <mat-label>No. of Fetus(es)</mat-label>
              <input
                type="text"
                matInput
                formControlName="no_of_fetus"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option
                  *ngFor="let option of NoofFetus"
                  [value]="option.OptionValue"
                >
                  {{ option.OptionName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Technical Conditions</mat-label>
              <input
                type="text"
                matInput
                formControlName="tech_condition"
                [matAutocomplete]="auto1"
              />
              <mat-autocomplete #auto1="matAutocomplete">
                <mat-option
                  *ngFor="let option of TechnicalConditions"
                  [value]="option.OptionValue"
                >
                  {{ option.OptionName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Fetal Heart Beat</mat-label>
              <input
                type="text"
                matInput
                formControlName="fetal_heart_beat"
                [matAutocomplete]="auto2"
              />
              <mat-autocomplete #auto2="matAutocomplete">
                <mat-option
                  *ngFor="let option of FetalHeartBeat"
                  [value]="option.OptionValue"
                >
                  {{ option.OptionName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Mean G.S.D (mm)</mat-label>
              <input formControlName="mean_gsd" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>C.R.L (mm)</mat-label>
              <input formControlName="crl" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>N.T Thickness (mm)</mat-label>
              <input formControlName="nt_thikness" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>US Average G.A (mm)</mat-label>
              <input formControlName="us_average" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Gender</mat-label>
              <input
                type="text"
                matInput
                formControlName="gender"
                [matAutocomplete]="auto3"
              />
              <mat-autocomplete #auto3="matAutocomplete">
                <mat-option
                  *ngFor="let option of gender"
                  [value]="option.OptionValue"
                >
                  {{ option.OptionName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Amniotic Fluid</mat-label>
              <input
                type="text"
                matInput
                formControlName="amniotic_fluid"
                [matAutocomplete]="auto4"
              />
              <mat-autocomplete #auto4="matAutocomplete">
                <mat-option
                  *ngFor="let option of AmnioticFluid"
                  [value]="option.OptionValue"
                >
                  {{ option.OptionName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Cervical OS</mat-label>
              <input
                type="text"
                matInput
                formControlName="cervical_os"
                [matAutocomplete]="auto5"
              />
              <mat-autocomplete #auto5="matAutocomplete">
                <mat-option
                  *ngFor="let option of CervicalOs"
                  [value]="option.OptionValue"
                >
                  {{ option.OptionName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </span>
        </div>

        <div class="right">
          <span class="input">
            <mat-form-field>
              <mat-label>B.P.D (mm)</mat-label>
              <input formControlName="bpd" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>F.L (mm)</mat-label>
              <input formControlName="fl" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>A.C (mm)</mat-label>
              <input formControlName="ac" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>H.C (mm)</mat-label>
              <input formControlName="hc" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>EFW (kg)</mat-label>
              <input formControlName="efw" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Placenta Location</mat-label>
              <input
                type="text"
                matInput
                formControlName="p_location"
                [matAutocomplete]="auto6"
              />
              <mat-autocomplete #auto6="matAutocomplete">
                <mat-option
                  *ngFor="let option of PlacentaLocation"
                  [value]="option.OptionValue"
                >
                  {{ option.OptionName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>USS EDD</mat-label>
              <input formControlName="uss_edd" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Left Adnexium</mat-label>
              <input formControlName="left_adnexium" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Right Adnexium</mat-label>
              <input formControlName="right_adnexium" matInput placeholder="" />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Dr.</mat-label>
              <mat-select formControlName="doctor_id" matNativeControl>
                <mat-option *ngFor="let dr of drs" [value]="dr.id">{{
                  dr.name
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </span>
        </div>
      </div>
    </div>

    <div class="space"></div>
    <mat-divider style="margin-bottom: 30px"></mat-divider>
    <!-- <h3>Overider finalizer</h3> -->
    <div class="form">
      <div class="others">
        <div class="left">
          <div style="margin-left: 30px">
            <mat-form-field>
              <mat-label>Select Finalizer.</mat-label>
              <mat-select
                matNativeControl
                [(ngModel)]="dr"
                required
                (selectionChange)="drValue($event)"
              >
                <mat-option
                  *ngFor="let data of otherdrs"
                  [value]="data.Employee_id"
                >
                  {{ data.First_Name }} {{ data.Middle_Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="right">
          <div style="margin-left: 30px">
            <mat-form-field>
              <mat-label>Select Initializer.</mat-label>
              <mat-select
                matNativeControl
                [(ngModel)]="initialdr"
                required
                (selectionChange)="initatorValue($event)"
              >
                <mat-option
                  *ngFor="let data of otherdrs"
                  [value]="data.Employee_id"
                >
                  {{ data.First_Name }} {{ data.Middle_Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <button
        class="button"
        mat-raised-button
        color="primary"
        (click)="overide()"
      >
        Overide
      </button>
    </div>

    <div class="space"></div>
    <mat-divider style="margin-bottom: 30px"></mat-divider>
    <div class="form">
      <div class="others">
        <div class="left">
          <span class="input">
            <mat-form-field>
              <mat-label>Other Findings</mat-label>
              <textarea formControlName="other_finding" matInput></textarea>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Comments</mat-label>
              <textarea formControlName="comments" matInput></textarea>
            </mat-form-field>
          </span>
        </div>

        <div class="right">
          <div class="space1"></div>
          <span class="example">
            <mat-checkbox
              style="margin: 20px"
              color="primary"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="suggestion1"
              >A Repeat scan in 2 weeks is Advised</mat-checkbox
            >
          </span>
          <div class="space1"></div>
          <span class="example">
            <mat-checkbox
              style="margin: 20px"
              color="primary"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="suggestion2"
              >A mid-trimester Anomally Scan at 16-24 weeks G.A is
              advised</mat-checkbox
            >
          </span>
          <div class="space1"></div>
          <span class="example">
            <mat-checkbox
              style="margin: 20px"
              color="primary"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="suggestion3"
              >Please come with a copy of this report at your next
              appointment</mat-checkbox
            >
          </span>
        </div>
      </div>
    </div>

    <div class="button">
      <button
        [disabled]="disable"
        type="submit"
        class="button"
        mat-raised-button
        color="primary"
        *ngIf="!isLoading"
      >
        Save
      </button>
      <button
        [disabled]="disable"
        type="submit"
        class="button"
        mat-raised-button
        color="primary"
        *ngIf="isLoading"
      >
        <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
      </button>

      <a routerLink="/Result-entry" class="waves-effect">
        <button
          type="button"
          style="margin-left: 20px"
          class="button"
          mat-raised-button
          color="primary"
        >
          Cancel
        </button>
      </a>
    </div>
  </div>
</form>
